import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-exception-log',
  templateUrl: './exception-log.component.html',
  styles: [
  ]
})
export class ExceptionLogComponent   {
  @Input() exceptionLog;
  @Input() modelHeader;

  constructor(public activeModal: NgbActiveModal) { }
  
}
